module.exports = __webpack_public_path__ + "img/restitution-approvisionnement.30b51344.png";